import React, {useEffect, useState} from 'react'
import {
  Route,
  Switch
} from 'react-router-dom';
import {
    CButton, CContainer, CModal,
    CModalBody, CModalFooter, CModalHeader,
    CModalTitle, CTextarea, CToast,
    CToastBody, CToaster, CToastHeader
} from '@coreui/react';
import {useDispatch, useSelector} from "react-redux";
import {todasAsPaginas} from "../../contentRoutes";
import {GuardaPagina, PaginaInicial, PaginaNaoEncontrada} from "../../components/acesso";
import Loading from "../../components/loader";
import {States} from "../../store/ducks/rootReducer";
import {LoadingStatusTypes} from "../../store/ducks/loading/types";
import {removeAlert} from "../../store/ducks/alert/actions";
import {createSelector} from "reselect";

interface ErrorModalProps{
    msg:string,
    title?:string,
    details?:string
    id?:number
    type?:'danger' | 'warning' | 'success',
    fnOk?: any
}

interface ToastyProps extends ErrorModalProps{}

const ErrorModal = (props:ErrorModalProps) =>{
    const [showDetail, setShowDetail]  = useState(false);
    const [showModal, setShowModel]  = useState(true);

    const dispatch = useDispatch();

    const handleOnCloseModal = ()=>{
        if(props.id){
            dispatch(removeAlert(props.id));
        }
    }

    const handleOnClickOk = ()=>{
        setShowModel(false);
        if(props.fnOk){
            props.fnOk();
        }
    }

    return (
        <CModal
            show={showModal}
            onClosed={handleOnCloseModal}
            color="danger"
        >
            <CModalHeader closeButton>
                <CModalTitle>{props.title}</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <p className="pb-2">
                    {props.msg}
                </p>
                {showDetail && <CTextarea rows={8} readOnly={true} value={props.details}></CTextarea> }
            </CModalBody>
            <CModalFooter>
                <CButton color="success" onClick={handleOnClickOk}>
                    Ok
                </CButton>
                {props.details && (
                    <CButton color="secondary" onClick={()=>setShowDetail(!showDetail)}>
                        Detalhes
                    </CButton>
                )}
            </CModalFooter>
        </CModal>
    )
}

const Toasty = (props:ToastyProps)=>{
    const dispatch = useDispatch();

    // Sai do store quando termina de sumir: senão os toasts acumulam e o limite abaixo apagava o mais novo
    const handleStateChange = (state: boolean | string) => {
        if (state === false && props.id) {
            dispatch(removeAlert(props.id));
        }
    }

    return (
        <CToast
            key={'toast' + props.id}
            show={true}
            autohide={3000}
            fade={true}
            color={props.type ? props.type : "success"}
            onStateChange={handleStateChange}
        >
            {props.title && (
                <CToastHeader closeButton={true}>
                    {props.title}
                </CToastHeader>
            )}
            <CToastBody>
                {props.msg}
            </CToastBody>
        </CToast>
    )
}

const TheContent = () => {
  const loadingState = useSelector((state:States)=> state.loading);
  const dispatch = useDispatch();

  const modalErrorSelect = createSelector((state:States)=>state.alert, alert=>alert.alerts.filter(alert=>!alert.toaster));
  const toastSelect      = createSelector((state:States)=>state.alert, alert=>alert.alerts.filter(alert=>alert.toaster));

  const modalsErrors = useSelector(modalErrorSelect);
  const toasts       = useSelector(toastSelect);

  // Limite de segurança: descarta só os toasts mais antigos (nunca o que acabou de chegar nem os modais de erro)
  useEffect(()=>{
      if(toasts.length > 10){
          toasts.slice(0, toasts.length - 10).forEach(toast => toast.id && dispatch(removeAlert(toast.id)));
      }
  }, [toasts, dispatch]);

  return (
    <main>
        {loadingState.state === LoadingStatusTypes.DISPLAY_ON && (<Loading/>)}
      <CContainer fluid className={'render-container'}>
          {modalsErrors.map(alert=>(
              <ErrorModal key={alert.id} {...alert} />
          ))}

          <CToaster
              position="bottom-right"
          >
              {toasts.map(toast => (
                  <Toasty key={toast.id} {...toast}/>
              ))}
          </CToaster>
          <Switch>
            {/* Toda pagina passa pela guarda: link direto tambem (#484909). */}
            {todasAsPaginas.map(({component: Pagina, path, exact})=>(
                 <Route key={path} path={path} exact={exact} render={(props)=>(
                     <GuardaPagina pagina={path}>
                         <Pagina {...props}/>
                     </GuardaPagina>
                 )}/>
            ))}
            <Route exact path="/" component={PaginaInicial}/>
            <Route component={PaginaNaoEncontrada}/>
          </Switch>
      </CContainer>
    </main>
  )
}

export default TheContent